/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Drastic_Tech_Stderr_LogInputs */



/**
* | output |
* | --- |
* | "[DRASTIC stderr]: {message}" |
*
* @param {Drastic_Tech_Stderr_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_stderr_log = /** @type {((inputs: Drastic_Tech_Stderr_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Stderr_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`[DRASTIC stderr] : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`[DROSTIC stderr]: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`[Error de salida DRÁSTICO]: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`[अत्यधिक गंभीर मानक त्रुटि]: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`[Deriva padrão DRASTIC]: ${i?.message}`)
	return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
});